<div id="seminars" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">
        <h2 class="title text-center">Seminars and Workshops</h2>

        <p class="text-center" style="color: var(--orange); font-weight: 600;">
          “Knowledge Beyond the Classroom”
        </p>

        <p class="inner-lead text-center">
          At Shah Satnam Ji Girls’ College, Sirsa, we believe in holistic education that goes beyond textbooks.
          Our commitment to empowering students is reflected in the diverse range of seminars and workshops
          we organize throughout the academic year. These sessions are designed to enhance knowledge,
          develop essential skills, and create awareness of various important issues.
        </p>

        <!-- Image Gallery -->
        <div class="row g-3 my-4">
          <div class="col-6 col-md-4" *ngFor="let img of [
            '/assets/img/iqac/seminar/1.jpg',
            '/assets/img/iqac/seminar/2.jpg',
            '/assets/img/iqac/seminar/3.jpg',
            '/assets/img/iqac/seminar/4.jpg',
            '/assets/img/iqac/seminar/5.jpg',
            '/assets/img/iqac/seminar/6.jpg',
            '/assets/img/iqac/seminar/7.jpg',
            '/assets/img/iqac/seminar/8.jpg',
            '/assets/img/iqac/seminar/9.jpg'
          ]">
            <div class="gallery-img-wrap">
              <img [src]="img" class="img-fluid gallery-img" alt="Seminar Image">
            </div>
          </div>
        </div>

        <!-- Content Sections -->
        <div class="content-sections">
          <p class="inner-lead"><b>Communication Skills:</b><br>
            Effective Communication is key to success in all walks of life. Our workshops on communication skills help students improve their verbal and non-verbal communication, public speaking, and interpersonal skills.
          </p>

          <p class="inner-lead"><b>Environment Pollution:</b><br>
            Understanding the impact of Pollution is crucial for future generations. We host seminars that educate students about environmental issues, sustainable practices, and the importance of conservation.
          </p>

          <p class="inner-lead"><b>Constitution Awareness:</b><br>
            Knowledge of the Constitution is fundamental for every citizen. Our constitution awareness seminars enlighten students about their rights, duties, and the significance of the Indian Constitution in maintaining democracy and justice.
          </p>

          <p class="inner-lead"><b>Computing Techniques:</b><br>
            In the digital age, proficiency in computing is essential. Our workshops cover the latest computing techniques, software skills, and IT trends, preparing students for technology-driven careers.
          </p>

          <p class="inner-lead"><b>Entrepreneurship:</b><br>
            To foster a spirit of innovation and self-reliance, we conduct entrepreneurship workshops. These sessions guide students on how to start and manage their businesses, encouraging creativity and risk-taking.
          </p>

          <p class="inner-lead"><b>AIDS Awareness:</b><br>
            Raising awareness about AIDS is crucial for public health. Our seminars provide comprehensive information about HIV/AIDS, prevention methods, and the importance of compassion and support for affected individuals.
          </p>

          <p class="inner-lead"><b>Gender Inequality:</b><br>
            Promoting gender equality is at the heart of our mission. Workshops on gender inequality address issues of discrimination, gender roles, and empowerment, aiming to create a more just and equal society.
          </p>

          <p class="inner-lead"><b>Awareness:</b><br>
            The dangers of drug abuse are a serious concern. Our drug awareness seminars educate students about the risks of drug use, prevention strategies, and ways to seek help for addiction.
          </p>

          <p class="inner-lead">
            Each seminar and workshop is led by experts and professionals who bring in-depth knowledge and practical insights to the table. We aim to equip our students with the necessary tools to thrive in a rapidly changing world, making them responsible, informed, and proactive individuals.
          </p>

          <p class="inner-lead" style="font-weight: 600;">
            Join us at Shah Satnam Ji Girls’ College, Sirsa, where learning transcends the classroom, and every student is encouraged to grow into a well-rounded individual ready to face the challenges of tomorrow.
          </p>
        </div>

        <!-- Yearly Table -->
        <!-- Yearly Table -->
<div class="ranked mt-4">
  <table class="table table-bordered table-hover text-center align-middle">
    <thead>
      <tr>
        <th>Session</th>
        <th>File Name</th>
        <th>View Report</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>2023–2024</td>
        <td>Seminars and Workshops 2023–24</td>
        <td>
          <a href="/assets/pdf/iqac/Seminars-and-Workshops-2023-24.pdf" target="_blank">
            <i class="fa-regular fa-eye"></i>
          </a>
        </td>
      </tr>
      <tr>
        <td>2022–2023</td>
        <td>Seminars and Workshops 2022–23</td>
        <td>
          <a href="/assets/pdf/iqac/Seminar-and-Workshops-2022-23.pdf" target="_blank">
            <i class="fa-regular fa-eye"></i>
          </a>
        </td>
      </tr>
      <tr>
        <td>2021–2022</td>
        <td>Seminars and Workshops 2021–22</td>
        <td>
          <a href="/assets/pdf/iqac/Seminars-and-Workshops-2021-22.pdf" target="_blank">
            <i class="fa-regular fa-eye"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>


      </div>
    </div>
  </div>
</div>
